import { CustomCheck } from '@warema/shared/authentication/models';

export enum Roles {
    // e.g. BASEDATA_ADMIN = 'basedata_admin',
}

export enum Permissions {
    // e.g. CARAVITA_INFORMATION_VIEW = 'caravita_information_view',
}

export type CustomCheckRole = Record<string, CustomCheck>;
